import React, { Component } from "react";
import Loader from "react-loader-spinner";
import { connect } from "react-redux";

class FullPageLoader extends Component {
  state = {};
  render() {
    const { loaderData } = this.props;
    if (loaderData && loaderData.isVisible) {
      return (
        <div
          style={{
            width: "100%",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "fixed",
            zIndex: 9999999,
            opacity: 0.95,
            backgroundColor: "white",
          }}
        >
          <div
            style={{
              width: 280,
              height: 200,
              textAlign: "center",
            }}
          >
            <Loader type="Oval" color="#2c4199" />
            {loaderData && loaderData.loaderText ? (
              <p
                style={{
                  fontFamily: "Mulish",
                  fontSize: 18,
                  marginTop: 10,
                  color: "#2c4199",
                  fontWeight: 600,
                }}
              >
                {loaderData.loaderText}
              </p>
            ) : (
              <div />
            )}
          </div>
        </div>
      );
    } else {
      return <div />;
    }
  }
}

const mapStateToProps = (state) => {
  return {
    loaderData: state.loaderData,
  };
};

export default connect(mapStateToProps, null)(FullPageLoader);
